import React from 'react';
interface CreditNoteCustomerProps {
  customer: {
    name: string;
    contact?: string;
    attn?: string;
  };
}
export function CreditNoteCustomer({
  customer
}: CreditNoteCustomerProps) {
  return <div className="mb-6 bg-neutral-50 border border-neutral-200 rounded-lg p-5" data-id="element-185">
      <p className="text-xs font-semibold text-neutral-700 mb-3" data-id="element-186">CUSTOMER:</p>
      <div className="space-y-1" data-id="element-187">
        <p className="font-semibold text-sm text-neutral-900" data-id="element-188">
          {customer.name}
        </p>
        {customer.contact && <p className="text-xs text-neutral-600" data-id="element-189">{customer.contact}</p>}
        {customer.attn && <p className="text-xs text-neutral-600" data-id="element-190">Attn: {customer.attn}</p>}
      </div>
    </div>;
}